/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { Form, Input, Typography } from "antd";

const { Title } = Typography;

interface ShippingInformationProps {
  onHandleBillingForm: (event: any) => void;
}

const ShippingInformation: React.FC<ShippingInformationProps> = ({
  onHandleBillingForm,
}: ShippingInformationProps) => {
  return (
    <div className="billing-information">
      <Title level={4} className="section-heading">
        Shipping Information
      </Title>
      <Form.Item
        label="Shipping Account #"
        name="shippingAccountNo"
        className="input-label"
        data-test-selector={"lblShippingAccount"}
      >
        <Input
          className="form-input"
          data-test-selector={"txtShippingAccount"}
          name="shippingAccountNo"
          maxLength={50}
          onChange={onHandleBillingForm}
        />
      </Form.Item>
      <Form.Item
        label="Shipping Address"
        name="shippingAddress"
        className="input-label"
        data-test-selector={"lblShippingAddress"}
      >
        <Input.TextArea
          className="form-input"
          data-test-selector={"txtShippingAddress"}
          name="shippingAddress"
          onChange={onHandleBillingForm}
        />
      </Form.Item>
    </div>
  );
};

export default ShippingInformation;
